import React from "react";
import "../styles/religious.css";
// तुमची इमेज येथे इम्पोर्ट करा
import swamiMandirImg from "../assets/images/swamimandir.jpeg"; 

export default function ReligiousPlaces() {
  const places = [
    {
      name: "श्री स्वामी समर्थ मंदिर",
      desc: "गावातील प्रमुख श्रद्धास्थान व वार्षिक उत्सवाचे केंद्र. येथे भक्तांना आध्यात्मिक शांतता व प्रसन्नता लाभते.",
      image: swamiMandirImg, // तुमची दिलेली इमेज येथे वापरली आहे
      icon: "🕉️",
      isMain: true
    },
    {
      name: "हनुमान मंदिर",
      desc: "शक्ती आणि भक्तीचे प्रतीक. हनुमान जयंती निमित्त येथे भव्य उत्सवाचे आयोजन केले जाते.",
      image: "https://images.unsplash.com/photo-1544911845-1f34a3eb46b1?q=80&w=600",
      icon: "🚩"
    },
    {
      name: "महादेव मंदिर",
      desc: "नदीकाठी वसलेले प्राचीन व निसर्गरम्य महादेव मंदिर. महाशिवरात्रीला येथे मोठी गर्दी असते.",
      image: "https://images.unsplash.com/photo-1564507592333-c60657451dd6?q=80&w=600",
      icon: "🔱"
    },
    {
      name: "दुर्गा माता मंदिर",
      desc: "गावाचे जागृत देवस्थान. नवरात्र उत्सवात नऊ दिवस येथे विविध धार्मिक कार्यक्रमांची रेलचेल असते.",
      image: "https://images.unsplash.com/photo-1625406085114-1e09c855a019?q=80&w=600",
      icon: "🌸"
    }
  ];

  return (
    <div className="religious-container">
      
      {/* 🚩 मुख्य बॅनर */}
      <section className="religious-hero">
        <div className="hero-overlay">
          <span className="hero-sub">पावित्र्य • भक्ती • परंपरा</span>
          <h1>धार्मिक वारसा</h1>
          <p>बेलपिंपळगाव - जिथे श्रद्धा आणि संस्कृतीचा संगम होतो</p>
        </div>
      </section>

      {/* 🛕 मंदिरांची लिस्ट */}
      <section className="temple-content">
        <div className="section-header">
          <h2>आमची प्रमुख मंदिरे</h2>
          <div className="divider"></div>
        </div>

        <div className="temple-grid">
          {places.map((p, index) => (
            <div className={`temple-card-pro ${p.isMain ? 'highlight' : ''}`} key={index}>
              <div className="image-box">
                <img src={p.image} alt={p.name} />
                <div className="icon-overlay">{p.icon}</div>
              </div>
              <div className="info-box">
                <h3>{p.name}</h3>
                <p>{p.desc}</p>
                <button className="view-btn">अधिक माहिती</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 🕉️ आध्यात्मिक सुविचार */}
      <section className="spiritual-footer">
        <p>"धर्मो रक्षति रक्षितः"</p>
        <span>— ग्रामपंचायत बेलपिंपळगाव</span>
      </section>

    </div>
  );
}